import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import './i18n/i18n';
import { AuthWrapper } from './containers/Auth/AuthWrapper';
import { Layout } from './containers/App/Layout';
import { Logout } from './containers/Auth/Logout';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 2,
      refetchOnWindowFocus: true,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/app/playlists" />} />
        <Route path="/auth/logout" element={<Logout />} />
        <Route path="/auth/*" element={<AuthWrapper />} />

        <Route path="/app/*" element={<Layout />} />
      </Routes>
    </BrowserRouter>
  </QueryClientProvider>
);

export default App;
